export const menuConfigItems = {
  profile: {
    root: true,
    title: 'SUBMENU.PROFILE',
    translate: 'SUBMENU.PROFILE',
    page: 'settings/profile',
    activePages: ['settings/profile'],
  },

  users: {
    root: true,
    title: 'MENU.USERS',
    translate: 'MENU.USERS',
    bullet: 'dot',
    activePages: ['users'],
    page: 'users/customers',
    submenu: [
      { translate: 'SUBMENU.TEAM', title: 'SUBMENU.TEAM', page: 'users/managers' },
      {
        translate: 'SUBMENU.CUSTOMERS',
        title: 'SUBMENU.CUSTOMERS',
        page: 'users/customers',
        activePages: ['users/new', 'users/edit'],
      },
    ],
  },

  usersManager: {
    root: true,
    title: 'MENU.USERS',
    translate: 'MENU.USERS',
    bullet: 'dot',
    activePages: ['users'],
    page: 'users/customers',
    submenu: [
      {
        translate: 'SUBMENU.CUSTOMERS',
        title: 'SUBMENU.CUSTOMERS',
        page: 'users/customers',
        activePages: ['users/new', 'users/edit'],
      },
    ],
  },

  adminChats: {
    root: true,
    title: 'SUBMENU.CHATS',
    translate: 'SUBMENU.CHATS',
    bullet: 'dot',
    page: 'chats',
    activePages: ['chats'],
    submenu: [
      {
        title: 'HUMAN.CHATS',
        page: 'chats',
        translate: 'HUMAN.CHATS',
      },
      {
        title: 'CHATS.GPT',
        page: 'chats/list',
        translate: 'CHATS.GPT',
      },
    ],
  },

  settings: {
    root: true,
    title: 'MENU.SETTINGS',
    bullet: 'dot',
    translate: 'MENU.SETTINGS',
    activePages: ['products'],
    page: 'promocodes/list',
    submenu: [
      {
        title: 'MENU.PROMOCODES',
        translate: 'MENU.PROMOCODES',
        page: 'promocodes/list',
        activePages: ['promocodes', 'promocodes/edit', 'promocodes/new'],
      },
      {
        title: 'MENU.REFFERALS',
        translate: 'MENU.REFFERALS',
        page: 'refferals/list',
        activePages: ['refferals', 'refferals/edit', 'refferals/new'],
      },
      {
        title: 'MENU.TRANSACTIONS',
        translate: 'MENU.TRANSACTIONS',
        page: 'transactions/list',
        activePages: ['transactions'],
      },
      {
        title: 'MENU.TARIFFS',
        translate: 'MENU.TARIFFS',
        page: 'tariffs/list',
        activePages: ['tariffs'],
      },
      {
        title: 'REGIONS',
        translate: 'REGIONS',
        page: 'settings/regions',
        activePages: ['regions'],
      },
      {
        title: 'GPT',
        page: 'settings/gpt',
        activePages: ['gpt'],
      },
    ],
  },

  legal: {
    root: true,
    title: 'SUBMENU.LEGAL',
    translate: 'SUBMENU.LEGAL',
    bullet: 'dot',
    activePages: ['documents'],
    page: 'documents/legacy',
    submenu: [
      {
        title: 'SUBMENU.LEGAL_TERMS',
        translate: 'SUBMENU.LEGAL_TERMS',
        page: 'documents/legacy',
      },
      {
        title: 'SUBMENU.LEGAL_PRIVACY',
        translate: 'SUBMENU.LEGAL_PRIVACY',
        page: 'documents/privacy',
      },
      {
        title: 'SUBMENU.CHILD_SAFETY',
        translate: 'SUBMENU.CHILD_SAFETY',
        page: 'documents/childsafety',
      },
    ],
  },
};
